export default __webpack_public_path__ + "static/media/tea-set.edd27225.png";